import { CROP_TYPE } from "../crop.types";

export default (preferredCropAlias?: CROP_TYPE, fallbackCropAlias?: CROP_TYPE): any => {
    const findAspectRatio = (crop?: CROP_TYPE): any => {
        if (crop === "Square (1:1)") {
            return {
                aspectRatioX: 1,
                aspectRatioY: 1
            };
        }
        else if (crop === "Fullscreen (4:3)") {
            return {
                aspectRatioX: 4,
                aspectRatioY: 3
            };
        }
        else if (crop === "Widescreen (16:9)") {
            return {
                aspectRatioX: 16,
                aspectRatioY: 9
            };
        }
        else if (crop === "Ultrawide (21:9)") {
            return {
                aspectRatioX: 21,
                aspectRatioY: 9
            };
        }
        else if (crop === "Superwide (32:9)") {
            return {
                aspectRatioX: 32,
                aspectRatioY: 9
            };
        }
        else {
            return undefined;
        }
    };

    const aspectRatio = findAspectRatio(preferredCropAlias);

    if (typeof (aspectRatio) !== "undefined") {
        return aspectRatio;
    }
    else {
        return findAspectRatio(fallbackCropAlias);
    }
};